export default __webpack_public_path__ + "static/media/Blue-Cake.bc25a177.jpg";